import { JobType } from './job_type';
const STATE_LABEL = {
    active: 'In progress',
    approved: 'Approved',
    rejected: 'Rejected',
    removed: 'Removed',
    warning: 'Approved with warnings'
};
/**
 * The job page shows a failed AML v2 screening as Warning. The list has no AML v2 data, so this
 * relies on api-service returning `result.aml.data` for v1 AML jobs only.
 */
export const isAmlV2Warning = (job, success) => job.request.type === JobType.idAml &&
    job.status === 'completed' &&
    !success &&
    !job.result?.aml?.data;
export const statusMapper = (status, success, warnings) => {
    let state = 'active';
    if (status === 'removed') {
        state = 'removed';
    }
    else if (status === 'completed' && !success) {
        state = 'rejected';
    }
    else if (status === 'completed' && success && warnings) {
        state = 'warning';
    }
    else if (status === 'completed' && success) {
        state = 'approved';
    }
    return { state, label: STATE_LABEL[state] };
};
